<template>
  <div class="ym-page">
    <!-- 顶部组件 -->
    <search-form :form="form" @search="search"></search-form>
    <!-- 列表 -->
    <table-list :datas="searchVal"></table-list>

  </div>
</template>

<script>
import SearchForm from './component/SearchForm.vue'
import TableList from './component/TableList.vue'
export default {
  components: {
    SearchForm,
    TableList
  },
  data() {
    return {
      // 表单
      form: {
        publicKey: '', // 链上账户
        token: '', // 记账哈希
        type: null // 记账类型（默认全部）
      },
      searchVal: {
        publicKey: '', // 链上账户
        token: '', // 记账哈希
        type: null // 记账类型（默认全部）
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    search(form) {
      // 重置表单
      this.form = form
      // 搜索列表
      let _form = JSON.parse(JSON.stringify(form))
      // if (_form.publicKey) {
      //   this.searchVal.publicKey = _form.publicKey
      // }
      // if (_form.tokens) {
      //   _form.tokens = 'tokens.' + _form.tokens
      // }
      // if (_form.nonToken) {
      //   _form.nonToken = 'nonToken.' + _form.nonToken
      // }
      this.searchVal = _form
      console.log('点击搜索:', this.searchVal)
    }
  }
}
</script>

<style lang='scss' scoped>
::v-deep {
  .el-input__inner {
    // width: 180px !important;
  }
}
.head-title {
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  margin-right: 16px;
}
.left {
  margin-left: 16px;
}
</style>
